import { GetLodgingsCountState, GetLodgingsCountActionTypes, GET_LODGINGS_COUNT_DATA_REQUEST, GET_LODGINGS_COUNT_DATA_SUCCESS, GET_LODGINGS_COUNT_DATA_FAILURE } from "store/reducers/lodgingOption/get-count/types";

const defaultState: GetLodgingsCountState = {
  isLoading: false,
  errorMessage: ""
};

export default function getLodgingsCount(state = defaultState, action: GetLodgingsCountActionTypes): GetLodgingsCountState {
  switch (action.type) {
    case GET_LODGINGS_COUNT_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_LODGINGS_COUNT_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_LODGINGS_COUNT_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};